import { Link } from "react-router-dom";
import ScrollReveal from "@/components/ScrollReveal";
import SEOHead from "@/components/SEOHead";

const h2 = { fontFamily: "'Cabinet Grotesk', sans-serif", fontSize: '24px', fontWeight: 800, color: '#1a1a1a', marginTop: '48px', marginBottom: '16px', paddingBottom: '8px', borderBottom: '2px solid #8B0000' };
const h3 = { fontSize: '18px', fontWeight: 700, color: '#1a1a1a', marginTop: '24px', marginBottom: '8px' };
const ul = { paddingLeft: '24px', marginBottom: '16px' };
const red = { color: '#8B0000' };

export default function MentionsLegales() {
  return (
    <div data-testid="mentions-legales-page" style={{ backgroundColor: '#fff', color: '#1a1a1a' }}>
      <SEOHead title="Mentions légales & Politique de confidentialité | VGI Construct SRL" description="Mentions légales, politique de confidentialité RGPD et politique de cookies de VGI Construct SRL. BCE/TVA BE 0705.849.204, Sint-Pieters-Leeuw." path="/mentions-legales" />

      <section style={{ backgroundColor: '#0a0a0a', padding: '60px 0' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 24px' }}>
          <p style={{ color: '#8B0000', fontSize: '12px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.2em', marginBottom: '12px' }}>Informations juridiques</p>
          <h1 style={{ fontFamily: "'Cabinet Grotesk', sans-serif", fontSize: 'clamp(2rem, 4vw, 3rem)', fontWeight: 900, color: '#fff', lineHeight: 1.1 }}>Mentions légales & Confidentialité</h1>
        </div>
      </section>

      <section style={{ padding: '48px 0 64px' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 24px' }}>
          <ScrollReveal>
            <div className="legal-content" style={{ lineHeight: 1.8, fontSize: '15px', color: '#444' }}>

              <h2 style={{ ...h2, marginTop: '40px' }}>1. Mentions légales</h2>
              <h3 style={h3}>Identité de l'entreprise</h3>
              <div style={{ overflowX: 'auto' }}>
              <table data-testid="legal-identity" style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
                <tbody>
                {[
                  ["Dénomination sociale", "VGI Construct SRL"],
                  ["Forme juridique", "Société à responsabilité limitée (SRL)"],
                  ["BCE / TVA", "BE 0705.849.204"],
                  ["RPM", "Bruxelles (tribunal de l'entreprise néerlandophone)"],
                  ["Siège social", "Bergensesteenweg 24/8, 1600 Sint-Pieters-Leeuw, Belgique"],
                  ["Gérant", "Daniel Gheorghe"],
                  ["Téléphone", "+32 466 407 988"],
                  ["Email", "info@vgiconstruct.be"],
                  ["Site web", "https://vgiconstruct.be"],
                ].map(([label, value]) => (
                  <tr key={label} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={{ padding: '10px 12px', fontWeight: 700, color: '#1a1a1a', width: '180px' }}>{label}</td>
                    <td style={{ padding: '10px 12px' }}>{value}</td>
                  </tr>
                ))}
                </tbody>
              </table>
              </div>

              <h3 style={h3}>Hébergement</h3>
              <p>Ce site est hébergé par Emergent (emergent.sh). Les données sont stockées sur des serveurs sécurisés.</p>

              <h3 style={h3}>Propriété intellectuelle</h3>
              <p>L'ensemble du contenu de ce site (textes, images, logos, photographies, vidéos) est la propriété exclusive de VGI Construct SRL, sauf mention contraire. Toute reproduction, même partielle, est interdite sans autorisation écrite préalable.</p>

              <h2 style={h2}>2. Politique de confidentialité (RGPD)</h2>
              <p>Conformément au Règlement Général sur la Protection des Données (RGPD – Règlement UE 2016/679), VGI Construct SRL s'engage à protéger la vie privée des utilisateurs de son site.</p>

              <h3 style={h3}>Responsable du traitement</h3>
              <p>VGI Construct SRL, Bergensesteenweg 24/8, 1600 Sint-Pieters-Leeuw. Contact : <a href="mailto:info@vgiconstruct.be" style={red}>info@vgiconstruct.be</a></p>

              <h3 style={h3}>Données collectées</h3>
              <p>Nous collectons les données suivantes uniquement via nos formulaires de contact et de demande de devis :</p>
              <ul style={ul}>
                <li>Nom et prénom</li>
                <li>Adresse e-mail</li>
                <li>Numéro de téléphone</li>
                <li>Type de travaux souhaités, surface, commune et date de démarrage souhaitée</li>
                <li>Description du projet et, le cas échéant, photos ou plans que vous nous transmettez</li>
              </ul>

              <h3 style={h3}>Finalité du traitement</h3>
              <p>Vos coordonnées servent uniquement à traiter votre demande :</p>
              <ul style={ul}>
                <li>Répondre à vos demandes de devis et messages de contact</li>
                <li>Vous recontacter dans le cadre de votre projet</li>
                <li>Vous envoyer un e-mail de confirmation de réception de votre demande</li>
              </ul>
              <p>Vos données ne sont jamais vendues, louées ou partagées avec des tiers à des fins commerciales.</p>

              <h3 style={h3}>Sous-traitants et outils utilisés</h3>
              <ul style={ul}>
                <li><strong>Envoi d'e-mails – Resend</strong> : les notifications de demande et les e-mails de confirmation sont acheminés via le service Resend. Votre adresse e-mail et le contenu de votre demande transitent par ce prestataire.</li>
                <li><strong>Mesure d'audience – PostHog (hébergé par Emergent)</strong> : statistiques de fréquentation anonymisées (pages vues, appareil, pays). Cet outil n'est activé qu'après votre accord via le bandeau cookies.</li>
                <li><strong>Hébergement et stockage des fichiers – Emergent</strong> : hébergement du site, de la base de données et des pièces jointes (photos, plans) transmises avec votre demande.</li>
              </ul>

              <h3 style={h3}>Base légale du traitement</h3>
              <ul style={ul}>
                <li><strong>Votre consentement</strong> : en soumettant un formulaire sur notre site, vous consentez au traitement de vos données.</li>
                <li><strong>L'exécution de mesures précontractuelles</strong> : vos données sont nécessaires pour établir un devis et réaliser les travaux demandés.</li>
                <li><strong>L'intérêt légitime</strong> : améliorer nos services et gérer notre activité commerciale.</li>
              </ul>

              <h3 style={h3}>Durée de conservation</h3>
              <p data-testid="legal-retention">Les demandes de devis et de contact (et leurs pièces jointes) sont conservées <strong>24 mois</strong> après le dernier contact, sauf obligation légale de conservation plus longue (ex. : factures conservées 7 ans) ou conclusion d'un contrat.</p>

              <h3 style={h3}>Vos droits</h3>
              <p>Conformément au RGPD, vous disposez des droits suivants :</p>
              <ul style={ul}>
                <li><strong>Droit d'accès</strong> : obtenir une copie de vos données personnelles</li>
                <li><strong>Droit de rectification</strong> : corriger des données inexactes</li>
                <li><strong>Droit à l'effacement</strong> : demander la suppression de vos données</li>
                <li><strong>Droit à la limitation du traitement</strong></li>
                <li><strong>Droit à la portabilité des données</strong></li>
                <li><strong>Droit d'opposition</strong> au traitement de vos données</li>
              </ul>
              <p>Pour exercer votre droit d'accès ou de suppression, envoyez un e-mail à <a href="mailto:info@vgiconstruct.be" style={red}>info@vgiconstruct.be</a>. Nous nous engageons à y répondre dans un délai de 30 jours.</p>
              <p>Vous avez également le droit d'introduire une réclamation auprès de l'Autorité de Protection des Données (APD) : <a href="https://www.autoriteprotectiondonnees.be" target="_blank" rel="noopener noreferrer" style={red}>www.autoriteprotectiondonnees.be</a></p>

              <h3 style={h3}>Sécurité des données</h3>
              <p>Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données contre tout accès non autorisé, modification, divulgation ou destruction. Notre site utilise le protocole HTTPS pour sécuriser les échanges de données.</p>

              <h2 style={h2}>3. Politique de cookies</h2>
              <h3 style={h3}>Qu'est-ce qu'un cookie ?</h3>
              <p>Un cookie est un petit fichier texte déposé sur votre appareil lors de la visite d'un site web. Il permet au site de mémoriser certaines informations sur votre visite.</p>

              <h3 style={h3}>Cookies utilisés sur ce site</h3>
              <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px', border: '1px solid #e0e0e0', minWidth: '480px' }}>
                <thead>
                  <tr style={{ backgroundColor: '#f5f5f5' }}>
                    {["Type", "Finalité", "Durée"].map(t => <th key={t} style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 700, color: '#1a1a1a', borderBottom: '2px solid #e0e0e0' }}>{t}</th>)}
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={{ padding: '10px 12px', fontWeight: 600 }}>Cookies essentiels</td>
                    <td style={{ padding: '10px 12px' }}>Fonctionnement du site, mémorisation de votre choix cookies, session d'authentification admin</td>
                    <td style={{ padding: '10px 12px' }}>6 mois (choix cookies) / session</td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={{ padding: '10px 12px', fontWeight: 600 }}>Mesure d'audience (PostHog)</td>
                    <td style={{ padding: '10px 12px' }}>Statistiques de fréquentation anonymisées – uniquement après « Accepter »</td>
                    <td style={{ padding: '10px 12px' }}>12 mois max</td>
                  </tr>
                </tbody>
              </table>
              </div>

              <h3 style={h3}>Gestion des cookies</h3>
              <p>Aucun cookie non essentiel n'est déposé avant votre choix. Votre décision (Accepter / Refuser) est mémorisée 6 mois ; pour la modifier, effacez les données du site dans votre navigateur et rechargez la page. Vous pouvez aussi configurer votre navigateur pour refuser les cookies.</p>

              <h2 style={h2}>4. Modification de cette page</h2>
              <p>VGI Construct SRL se réserve le droit de modifier cette page à tout moment. Nous vous invitons à la consulter régulièrement. Dernière mise à jour : juin 2026.</p>

              <div style={{ marginTop: '48px', padding: '24px', backgroundColor: '#f5f5f5', borderRadius: '8px', textAlign: 'center' }}>
                <p style={{ margin: '0 0 12px', fontWeight: 700, color: '#1a1a1a' }}>Des questions sur vos données personnelles ?</p>
                <Link to="/contact" style={{ ...red, fontWeight: 700, textDecoration: 'none' }}>Contactez-nous</Link>
                <span style={{ margin: '0 12px', color: '#ccc' }}>|</span>
                <a href="mailto:info@vgiconstruct.be" style={{ ...red, fontWeight: 700, textDecoration: 'none' }}>info@vgiconstruct.be</a>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </section>
    </div>
  );
}
